__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "op-web-borrower-portal-wrapper-service";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@casl/ability", "6.8.1", () => (__webpack_require__.e(8496).then(() => (() => (__webpack_require__(18496))))));
			register("@casl/react", "5.0.1", () => (Promise.all([__webpack_require__.e(3858), __webpack_require__.e(3203)]).then(() => (() => (__webpack_require__(73203))))));
			register("@emotion/react", "11.10.4", () => (Promise.all([__webpack_require__.e(6159), __webpack_require__.e(3858), __webpack_require__.e(3649)]).then(() => (() => (__webpack_require__(73649))))));
			register("@emotion/styled", "11.10.4", () => (Promise.all([__webpack_require__.e(3858), __webpack_require__.e(2164), __webpack_require__.e(1479)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(6159), __webpack_require__.e(9232), __webpack_require__.e(8928), __webpack_require__.e(3858), __webpack_require__.e(3888), __webpack_require__.e(9817), __webpack_require__.e(2164), __webpack_require__.e(4976), __webpack_require__.e(3067)]).then(() => (() => (__webpack_require__(49232))))));
			register("@mui/styles", "5.18.0", () => (Promise.all([__webpack_require__.e(4420), __webpack_require__.e(3858), __webpack_require__.e(9817), __webpack_require__.e(6286)]).then(() => (() => (__webpack_require__(54420))))));
			register("@toorak/op-web-tw-component", "1.27.20", () => (Promise.all([__webpack_require__.e(6180), __webpack_require__.e(3858), __webpack_require__.e(3888), __webpack_require__.e(9817)]).then(() => (() => (__webpack_require__(96180))))));
			register("i18next", "21.10.0", () => (Promise.all([__webpack_require__.e(6203), __webpack_require__.e(6708)]).then(() => (() => (__webpack_require__(56203))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(4644), __webpack_require__.e(3858)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "11.18.6", () => (Promise.all([__webpack_require__.e(3858), __webpack_require__.e(5070)]).then(() => (() => (__webpack_require__(35070))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(5942), __webpack_require__.e(3858), __webpack_require__.e(3888)]).then(() => (() => (__webpack_require__(75942))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(3858), __webpack_require__.e(3888)]).then(() => (() => (__webpack_require__(92648))))));
			register("react/jsx-runtime", "18.3.1", () => (Promise.all([__webpack_require__.e(4644), __webpack_require__.e(3858)]).then(() => (() => (__webpack_require__(74848))))));
			register("react", "18.3.1", () => (__webpack_require__.e(4644).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};